/* global _, Toasts, MarketItemTagsViewModel, debug */

$(function () {
    'use strict';

    var currentItem;

    function MarketPlaceItem ($element, photos) {
        var $editForm = $element.find('[data-marketplace-item-edit-form]');
        var $cardView = $element.find('[data-marketplace-item-data-view]');
        var $editButton = $element.find('[data-marketplace-item-edit-button]');
        var $fields = $editForm.find(':input');
        var $deleteButton = $element.find('[data-marketplace-delete]');
        var $saveButton = $element.find('[data-marketplace-save]');
        var $photosHolder = $element.find('[data-marketplace-item-photos]');
        var idField = $fields.filter('#market_item_id');
        var itemId;
        var photoTemplate = _.template($('#market-place-photo-template').html());
        var $mainPhotoInput = $fields.filter('#market_item_main_photo_id');
        var $tagPanel = $element.find('[data-marketplace-tag-panel]');
        var rout = {
            setMainPhoto: $element.data('set-main-photo-url'),
            bindPhotos: $element.data('photo-bind-url'),
            unbindPhoto: $element.data('photo-unbind-url'),
            deleteItem: $element.data('delete-url')
        };

        var initPhoto = function ($photo) {
            $photo.find('.media__remove').on('click', function (event) {
                event.stopPropagation();
                unbindPhoto($photo.data('id'), $photo);
            });

            $photo.on('click', function () {
                $photosHolder.find('.media_selectable_selected').removeClass('media_selectable_selected');
                var $photoHolder = $(this);
                $photoHolder.addClass('media_selectable_selected');
                selectMainPhoto($photoHolder.data('id'), $photoHolder.data('photo-src'));
            });
        };

        var savingProcess = function (bool) {
            $element.toggleClass('marketplace-item_saving', bool);
            return bool;
        };

        var bindPhotos = function (photos) {
            if (!_(itemId).isUndefined()) {
                $.post(rout.bindPhotos, {
                    id: itemId,
                    photo_ids: _(photos).map(function (photo) {
                        return photo.id;
                    })
                });
            }
        };

        var initTagPanel = function (id) {
            var tagEditPanelId = $tagPanel.data('item-tag-edit-id');
            var tagEditPanelNewId = tagEditPanelId + '_' + id;
            $tagPanel.data('item-tag-edit-id', tagEditPanelNewId).attr('data-item-tag-edit-id', tagEditPanelNewId);
            var $tagEditModal = $('[data-item-tag-modal-id="' + tagEditPanelId + '"]');
            var $tagEditModalNew = $tagEditModal.clone(true);
            $tagEditModalNew.data('item-tag-modal-id', tagEditPanelNewId).attr('data-item-tag-modal-id', tagEditPanelNewId);
            var newModalId = $tagEditModalNew.attr('id').replace(/_(\w+)$/gi, '_$1_' + id);
            $tagEditModalNew.attr('id', newModalId);
            $tagPanel.find('.i-open-modal').attr('data-modal-id', newModalId).data('modal-id', newModalId);
            $tagEditModalNew.find('.i-close-modal').data('modal-id', newModalId);

            $tagEditModal.before($tagEditModalNew);

            var options = window.MarketItemTagsViewModelOptions[tagEditPanelId];
            if (options) {
                var newOptions = $.extend(true, {}, options);
                newOptions.item_id = id;
                var marketModel = new MarketItemTagsViewModel(newOptions);
                ko.applyBindings(marketModel, $tagPanel.get(0));
                ko.applyBindings(marketModel, $tagEditModalNew.get(0));
                $tagPanel.show();
            }
        };

        var selectMainPhoto = function (photoId, src) {
            $mainPhotoInput.prop('value', photoId);
            $cardView.find('.media__image').attr('src', src);

            if (!_(itemId).isUndefined()) {
                $.post(rout.setMainPhoto, {
                    id: itemId,
                    photo_id: photoId
                });
            }
        };

        var getData = function () {
            var data = $editForm.serialize();
            if (!_(itemId).isUndefined()) {
                data = data + '&' + $.param({ 'id': itemId });
            }
            var cachedData = $editForm.data('cached');
            if (_.isEqual(data, cachedData)) {
                return false;
            }
            else {
                $editForm.data('cached', data);
                return data;
            }
        };

        var printEror = function (data) {
            var dataObject = JSON.parse(data.responseText);
            if (_(dataObject).isObject()) {
                debug.log(dataObject.errors.global);
            }
        };

        if (idField.prop('value').length > 0) {
            itemId = idField.prop('value');
            $photosHolder.find('.marketplace-item__photos-item .media').each(function (index, photo) {
                initPhoto($(photo));
            });
        }
        else {
            var getItemId = function () {
                savingProcess(true);
                return $.post($editForm.attr('action'), getData());
            };

            var insertPhotos = function (photos, initial) {
                _(photos).each(function (photo, index) {
                    var $photo = $(photoTemplate(photo));
                    if (initial && index === 0) {
                        $photo.find('.media_selectable-w-caption').addClass('media_selectable_selected');
                    }

                    $photosHolder.append($photo);
                    initPhoto($photo.find('.media'));
                });
            };

            getItemId()
                .always(function () {
                    savingProcess(false);
                })
                .done(function (data) {
                    var dataObject = data;
                    if (_(dataObject).isObject() && dataObject.success) {
                        itemId = dataObject.id;
                        idField.prop('value', itemId);
                        $element.addClass('marketplace-item_created');
                        initTagPanel(itemId);
                        bindPhotos(photos);
                        selectMainPhoto($photosHolder.find('.media_selectable_selected').data('id'));
                    }
                })
                .fail(printEror);

            insertPhotos(photos, true);
        }

        var toggleEdit = function (toggle) {
            $element.toggleClass('marketplace-item_state_edit', toggle);
        };

        var fillCard = function (data) {
            _(data).each(function (value, key) {
                if (_(value).isString()) {
                    if (key === 'photo_src') {
                        $cardView.find('[data-field="' + key + '"]').attr('src', value);
                    }
                    else if (value.length > 0) {
                        $cardView.find('[data-field="' + key + '"]').text(value);
                    }
                }
                else if (_(value).isNumber()) {
                    $cardView.find('[data-field="' + key + '"]').text(value);
                }
            });
        };

        var unbindPhoto = function (photoId, $photo) {
            if (!_(itemId).isUndefined()) {
                $photo.parent().fadeOut('fast');
                return $.post(rout.unbindPhoto, {
                        id : itemId,
                        photo_id : photoId
                    })
                    .done(function () {
                        if ($photo.is('.media_selectable_selected')) {
                            $mainPhotoInput.prop('value', '');
                        }
                    })
                    .fail(function () {
                        Toasts.pushToast('Что-то пошло не так, попробуйте еще раз', 'fail', undefined, 4000);
                    });
            }
        };

        var trottledToast = _.throttle(function () {
            Toasts.pushToast('Данные успешно сохранены', 'success', undefined, 2000);
        }, 5000);

        var postData = function () {
            if (savingProcess() === true || _(itemId).isUndefined()) {
                return false;
            }
            else {
                savingProcess(true);
            }

            var data = getData();

            if (data) {
                return $.post($editForm.attr('action'), data)
                    .always(function () {
                        savingProcess(false);
                    })
                    .done(function (data) {
                        var dataObject = data;

                        if (_(dataObject).isObject() && dataObject.success) {
                            fillCard(dataObject.data);
                            trottledToast();
                        }
                    })
                    .fail(function (data) {
                        Toasts.pushToast('Что-то пошло не так', 'fail', undefined, 3000);
                        printEror(data);
                    });
            }
        };

        var deleteItem = function () {
            var sure = confirm('Вы действительно хотите удалить карточку товара?');
            if (sure) {
                $element.fadeOut();
                return $.post(rout.deleteItem, {id : itemId})
                    .done(function () {

                    })
                    .fail(function () {

                    });
            }
        };

        $editForm.on('change', postData.throttle(1000));

        $editForm.on('submit', function (event) {
            event.preventDefault();
        });

        $deleteButton.on('click', deleteItem);

        $saveButton.on('click', function () {
            var data = {};
            $fields.filter('input, textarea').each(function (index, field) {
                data[field.name.match(/\[.*]/)[0].replace(/\[/g, '').replace(/\]/g, '')] = $(field).prop('value');
            });
            fillCard(data);
            postData();
            toggleEdit(false);
        });

        $editButton.on('click', function () {
            toggleEdit(true);
        });

        $editForm.find('[name*="section_id_level_"]').on('change', function () {
            var val = $(this).val();
            var level = $(this).attr('name').replace(/^.*\[section_id_level_(\d+).*$/gi, '$1');
            var $sectionLevelNext = $editForm.find('[name*="section_id_level_' + (window.parseInt(level, 10) + 1) + '"]');

            if (!$sectionLevelNext || !$sectionLevelNext.length) {
                return false;
            }

            var $sections = $editForm.find('[name*="section_id_level_"]');

            $sectionLevelNext.val('').html('');
            $sections.each(function () {
                var sectionLevel = $(this).attr('name').replace(/^.*\[section_id_level_(\d+).*$/gi, '$1');
                if (sectionLevel > level) {
                    $(this).val('').html('').hide();
                }
            });

            if (!val) {
                $sectionLevelNext.hide();
            }
            else {
                var marketItemSections = window.MarketItemSections;
                if (level > 1) {
                    for (var i = 1; i < level; i++) {
                        var levelVal = $editForm.find('[name*="section_id_level_' + (i) + '"]').val();
                        marketItemSections = marketItemSections[levelVal]['children'];
                    }
                }
                var variants = marketItemSections[val];
                if (variants && variants['children']) {
                    for (var key in variants['children']) {
                        var variant = variants['children'][key];
                        var $option = $('<option value="' + variant['id'] + '">' + variant['name'] + '</option>');
                        $sectionLevelNext.append($option);
                    }
                    $sectionLevelNext.show();
                }
                else {
                    $sectionLevelNext.hide();
                }
            }
        });

        $editForm.find('[data-marketplace-add-photo-button]').on('click', function () {
            currentItem = {
                $photos: $photosHolder,
                initPhotos: function ($photos) {
                    _($photos).each(function ($photo) {
                        initPhoto($photo.find('.media'));
                    });
                },
                bindPhotos: bindPhotos
            };
        });
    }

    $(document).on('ready', function () {
        var $marketItems = $('[data-market-items]');

        var $createItemButton = $('[data-create-item-button]');

        function createNewItem (photos) {
            var $template = $($('#marketplace-item-template').html());
            $createItemButton.after($template);
            $('.marketplace__items-list').prepend($template);

            if ($marketItems.is('.marketplace-items_empty')) {
                $marketItems.removeClass('marketplace-items_empty');
            }

            return new MarketPlaceItem($template, photos);
        }

        var $marketplaceFilter = $('[data-marketplace-filter]');

        $marketplaceFilter.find('select').on('change', function () {
            $marketplaceFilter.trigger('submit');
        });

        $(document).trigger('PhotoUploadOverlay::registerCallback', [
            {
                name: 'add-marketplace-item',
                callbackFunction: function ($caller, photos, ideabook, size, isLast) {

                    $(document).trigger('PhotoUploadOverlay::hide');

                    _.defer(function() {
                        createNewItem(photos);
                    });
                }
            }
        ]);

        $(document).trigger('PhotoUploadOverlay::registerCallback', [
            {
                name: 'add-photos-to-marketplace-item',
                callbackFunction: function ($caller, photos, ideabook, size, isLast) {

                    $(document).trigger('PhotoUploadOverlay::hide');

                    var template = _.template($('#market-place-photo-template').html());

                    var photosItems = _(photos).map(function (photo) {
                        return $(template(photo));
                    });

                    _.defer(function () {
                        if (!_(currentItem).isUndefined()) {
                            _(photosItems).each(function ($photo) {
                                currentItem.$photos.append($photo);
                            });
                            currentItem.initPhotos(photosItems);
                            currentItem.bindPhotos(photos);
                        }
                    });
                }
            }
        ]);

        $('[data-marketplace-item]').each(function (index, element) {
            var item = MarketPlaceItem($(element));
        });

        var $itemGallery = $('.marketplace-item__gallery');
        if ($itemGallery.length) {
            var $prevItemImages = $itemGallery.find('.photooverlay__gallery__prev');
            var $currentItemImage = $itemGallery.find('.photooverlay__gallery__current');
            var $nextItemImages = $itemGallery.find('.photooverlay__gallery__next');
            var $itemImages = $itemGallery.find('.photooverlay__gallery__thumbnail');
            var $currentItemBigImage = $itemGallery.closest('.photooverlay__photopane').find('.photooverlay__photopane__image');
            $itemImages.on('click', function() {
                var id = $(this).data('id');
                var src = $(this).data('src');
                var currentFound = false;
                $itemImages.each(function() {
                    var $photo = $(this);
                    if ($photo.data('id') == id) {
                        $photo.appendTo($currentItemImage);
                        $currentItemBigImage.attr('src', src);
                        currentFound = true;
                    } else if (!currentFound) {
                        $photo.appendTo($prevItemImages);
                    } else {
                        $photo.appendTo($nextItemImages);
                    }
                });
            })
        }

    });
});
